module.exports = __webpack_public_path__ + "media/images/sort-desc-8fcbe60e4efd8e2d1742bba8486994e1.gif";